import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Md5 } from 'ts-md5'
import { login } from "../services/MSurveyService";

interface From {
    from?: {
        hash: string,
        key: string,
        pathname: string,
        search: string,
        state: null
    }
}

interface Invalid {
    username: boolean,
    password: boolean
}

export default function Login() {
    let navigate = useNavigate();
    let location = useLocation();
    let auth = useAuth();
    let from = location.state as From;
    let frompath = from?.from?.pathname || "/";
    let [username, setUsername] = useState('');
    let [password, setPassword] = useState('');
    let [invalid, setInvalid] = useState<Invalid | undefined>(undefined);

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (!(username && password)) {
            const _invalid = {
                username: !username ? false : true,
                password: !password ? false : true
            }
            setInvalid(_invalid);
            return;
        }

        const loginBody = {
            username: username,
            password: Md5.hashStr(password)
        }

        login(loginBody)
            .then(() => {
                auth.signin(username, () => {
                    navigate(frompath, { replace: true });
                });
            })
            .catch(err => {
                console.log(err)
                return;
            })


    }

    return (
        <Container>
            <Row>
                <Col>

                    <form className="form" onSubmit={handleSubmit}>
                        <Col lg={{ offset: 3, span: 6 }} md={12} sm={12}>
                            <div className="form-contact">
                                <div className="form-contact__title">
                                    <h1>MSurvey Login</h1>
                                </div>
                                <div className={`form-contact__inputs active`}>
                                    <label className="label" htmlFor="username">Username</label>
                                    <input
                                        className={`${invalid && invalid.username === false ? 'error' : ''}`}
                                        id="username"
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)} />
                                    <label className="label" htmlFor="password">Password</label>
                                    <input
                                        className={`${invalid && invalid.password === false ? 'error' : ''}`}
                                        id="password"
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)} />
                                </div>
                            </div>
                        </Col>
                        <button className="form-button__submit" type="submit">Login</button>
                    </form>
                </Col>
            </Row>

        </Container>
    );
}